"use client";

import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MissingClassmates() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235675" id="missing-classmates" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-2xl md:text-4xl font-semibold mb-8 text-accent tracking-widest uppercase">
            Who's Missing?
          </h2>

          <div className="mb-12 md:mb-16">
            <Link to="/AlumniRollCallPage" className="inline-block transition-transform duration-300 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
              <span className="font-serif text-[50px] sm:text-[60px] md:text-[80px] leading-none font-bold text-foreground tracking-tighter drop-shadow-md">
                Help Us Find Them
              </span>
            </Link>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-lg shadow-accent/20 bg-gradient-to-r from-accent to-chart-4 border-none text-primary-foreground font-default font-bold">
              <Link to="https://facebook.com">
                <Phone className="mr-2 size-5" />
                Share on Facebook
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 border-accent/40 hover:bg-accent/10 hover:text-accent font-default">
              <Link to="#">
                <Mail className="mr-2 size-5" />
                Copy Invite Link
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}